export interface CurrencyConfig {
  code: string
  symbol: string
  rate: number // Rate relative to EUR
}
export const currencies: Record<string, CurrencyConfig> = {
  EUR: { code: 'EUR', symbol: '€', rate: 1 },
  USD: { code: 'USD', symbol: '$', rate: 1.09 },
  GBP: { code: 'GBP', symbol: '£', rate: 0.85 },
  CAD: { code: 'CAD', symbol: 'CA$', rate: 1.47 },
  AUD: { code: 'AUD', symbol: 'A$', rate: 1.65 },
  CHF: { code: 'CHF', symbol: 'CHF', rate: 0.94 },
  SEK: { code: 'SEK', symbol: 'kr', rate: 11.35 },
  NOK: { code: 'NOK', symbol: 'kr', rate: 11.68 },
  DKK: { code: 'DKK', symbol: 'kr', rate: 7.46 },
  PLN: { code: 'PLN', symbol: 'zł', rate: 4.32 },
  CZK: { code: 'CZK', symbol: 'Kč', rate: 24.72 },
}
// Map country codes to currency codes
const countryCurrencyMap: Record<string, string> = {
  US: 'USD',
  GB: 'GBP',
  CA: 'CAD',
  AU: 'AUD',
  NZ: 'AUD',
  CH: 'CHF',
  SE: 'SEK',
  NO: 'NOK',
  DK: 'DKK',
  PL: 'PLN',
  CZ: 'CZK',
  // EU countries use EUR
  AT: 'EUR',
  BE: 'EUR',
  CY: 'EUR',
  EE: 'EUR',
  FI: 'EUR',
  FR: 'EUR',
  DE: 'EUR',
  GR: 'EUR',
  IE: 'EUR',
  IT: 'EUR',
  LV: 'EUR',
  LT: 'EUR',
  LU: 'EUR',
  MT: 'EUR',
  NL: 'EUR',
  PT: 'EUR',
  SK: 'EUR',
  SI: 'EUR',
  ES: 'EUR',
}
export async function detectUserCurrency(): Promise<string> {
  try {
    // Try to get user's country from ipapi.co
    const response = await fetch('https://ipapi.co/json/')
    const data = await response.json()
    const countryCode = data.country_code
    // Return the currency for that country, default to EUR
    return countryCurrencyMap[countryCode] || 'EUR'
  } catch (error) {
    // Fallback: try to detect from browser locale
    const locale = navigator.language || 'en-US'
    const countryCode = locale.split('-')[1]
    return countryCurrencyMap[countryCode] || 'EUR'
  }
}
export function convertPrice(
  priceInEur: number,
  targetCurrency: string,
): string {
  const currency = currencies[targetCurrency] || currencies.EUR
  const convertedAmount = priceInEur * currency.rate
  // Round to nearest 50 or 100 for cleaner pricing
  const rounded =
    convertedAmount > 1000
      ? Math.round(convertedAmount / 100) * 100
      : Math.round(convertedAmount / 50) * 50
  return `${currency.symbol}${rounded.toLocaleString()}`
}
export function formatPriceRange(
  minPriceEur: number,
  maxPriceEur: number,
  targetCurrency: string,
): string {
  const currency = currencies[targetCurrency] || currencies.EUR
  const minConverted = minPriceEur * currency.rate
  const maxConverted = maxPriceEur * currency.rate
  const minRounded =
    minConverted > 1000
      ? Math.round(minConverted / 100) * 100
      : Math.round(minConverted / 50) * 50
  const maxRounded =
    maxConverted > 1000
      ? Math.round(maxConverted / 100) * 100
      : Math.round(maxConverted / 50) * 50
  return `${currency.symbol}${minRounded.toLocaleString()} - ${currency.symbol}${maxRounded.toLocaleString()}`
}
